import { useRef } from "react";
import { useParams } from "react-router-dom";
import { BlogCard } from "../BlogCard/BlogCard";
import { IconSvg } from "../../../../utils/constants/icons/iconSvg.constant";
import { useSwiper } from "../../../../hooks/useSwiper";
import "./BlogCategory.scss";

export const BlogCategory = ({ group }) => {
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const { lang } = useParams();

  const { width, cardWidth, offset, scrollBy, atStart, atEnd, mode } = useSwiper({
    containerRef,
    trackRef,
    cardClassName: "blog-category__card",
    gap: 16,
    breakpoints: [
      { width: 0, items: "scroll" },
      { width: 768, items: 2 },
      { width: 993, items: 3 }
    ]
  });

  const groupName = group.groupNamesByLocale?.[lang];

  const groupColor = group?.groupColor || "green";

  const isSliderButtonsAvailable = () => {
    if (width < 768) return false;

    if (width >= 768 && width < 993) {
      return group?.articles?.length > 2;
    }

    return group?.articles?.length > 3;
  };

  return (
    <div className={`blog-category blog-category--${groupColor}`}>
      <div className="blog-category__heading">
        {groupName && (
          <button className="blog-category__button blog-category__button--info">
            <IconSvg tag={group.groupIconName ? `blog-${group.groupIconName}` : "blog-info"}/>
            <span>{groupName}</span>
          </button>
        )}
        {mode === "translate" && isSliderButtonsAvailable() && (
          <div className="blog-category__slider-arrows">
            <button
              className="blog-category__slider-arrow blog-category__slider-arrow--right"
              disabled={atStart}
              onClick={() => scrollBy("left")}
            >
              <IconSvg tag="classicArrowLeft"/>
            </button>
            <button
              className="blog-category__slider-arrow blog-category__slider-arrow--left"
              disabled={atEnd}
              onClick={() => scrollBy("right")}
            >
              <IconSvg tag="classicArrowLeft" />
            </button>
          </div>
        )}
      </div>
      <div className="blog-category__container" ref={containerRef}>
        <div
          className="blog-category__track"
          ref={trackRef}
          style={{
            transform: mode === "translate" ? `translateX(-${offset}px)` : "none",
            overflowX: mode === "scroll" ? "auto" : "unset"
          }}
        >
          {group?.articles?.map(({ title, createdDate, tag }) => (
            <div
              className="blog-category__card"
              key={tag}
              style={{
                width: mode === "translate" ? `${cardWidth}px` : "100%",
                minWidth: mode === "translate" ? `${cardWidth}px` : "100%"
              }}
            >
              <BlogCard title={title} date={createdDate} color={groupColor} tag={tag} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
